import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";

type QA = { q: string; a: string };

const ITEMS: QA[] = [
  {
    q: "اکانت‌های هوش مصنوعی چطور تحویل داده می‌شوند؟",
    a: "پس از ثبت سفارش و پرداخت کارت به کارت و تأیید کارشناسان، اطلاعات اکانت در پنل کاربری شما قرار می‌گیرد و قابل مشاهده خواهد بود.",
  },
  {
    q: "دوره‌ها چه فرمتی دارند؟",
    a: "دوره‌ها با استاندارد SCORM ارائه می‌شوند و پیشرفت یادگیری شما به‌صورت خودکار ذخیره می‌شود؛ از هر دستگاهی که وارد شوید، یادگیری را ادامه می‌دهید.",
  },
  {
    q: "سیستم کمیسیون چطور کار می‌کند؟",
    a: "پس از ثبت‌نام، یک کد معرف اختصاصی دریافت می‌کنید؛ دوستانتان با آن کد ثبت‌نام می‌کنند و به‌ازای هر خرید زیرمجموعه، درصدی به‌عنوان کمیسیون به حساب شما اضافه می‌شود.",
  },
  {
    q: "آیا دوره‌ها رایگان هستند؟",
    a: "برخی دوره‌ها رایگان و برخی پولی هستند؛ قیمت هر دوره در صفحه همان دوره مشخص شده است.",
  },
  {
    q: "آیا برای شرکت در دوره‌ها باید اکانت بسازم؟",
    a: "بله، ابتدا ثبت‌نام کنید و سپس در دوره دلخواهتان ثبت‌نام کنید تا پیشرفت یادگیری شما ذخیره شود.",
  },
  {
    q: "اگر سفارش سایت یا اپلیکیشن داشتم چه کنم؟",
    a: "از بخش «سفارش پروژه»، درخواست خود را با ذکر نوع پروژه و توضیحات ثبت کنید تا کارشناسان ما با شما تماس بگیرند.",
  },
];

export function FAQ() {
  return (
    <section id="faq" aria-labelledby="faq-heading" className="py-20 md:py-24">
      <div className="mx-auto w-full max-w-3xl px-4">
        <div className="text-center">
          <span className="inline-flex items-center rounded-full border border-primary/30 bg-primary/10 px-3 py-1 text-xs font-medium text-primary">
            سوالات متداول
          </span>
          <h2
            id="faq-heading"
            className="mt-4 text-3xl font-bold tracking-tight sm:text-4xl"
          >
            پاسخ پرسش‌های پرتکرار شما
          </h2>
          <p className="mt-3 text-muted-foreground">
            اگر سوال دیگری دارید، از طریق شماره پشتیبانی با ما در ارتباط باشید.
          </p>
        </div>

        <Accordion
          type="single"
          collapsible
          className="mt-10 w-full rounded-2xl border border-border bg-card p-2"
        >
          {ITEMS.map((item, idx) => (
            <AccordionItem
              key={item.q}
              value={`item-${idx}`}
              className="rounded-lg px-3 data-[state=open]:bg-accent/40 transition-colors"
            >
              <AccordionTrigger className="text-right text-base font-medium">
                {item.q}
              </AccordionTrigger>
              <AccordionContent className="text-right text-sm leading-relaxed text-muted-foreground">
                {item.a}
              </AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
      </div>
    </section>
  );
}

export default FAQ;
